import React from 'react'
import PropTypes from 'prop-types'
import Link from 'gatsby-link'
import CardGrid from '../components/card-grid/card-grid'
import Jumbotron from '../components/jumbotron/jumbotron'
import Layout from '../components/layout'
import StructuredData from "../components/structured-data";
import SeoTags from '../components/seo-tags'

import * as utils from '../utils'

const TITLE = "Autokwix - off-road trucks Mods & Performance Parts ratings";
const DESCRIPTION = "Autokwix.com - off-road trucks and SUVs Accessories & Performance Parts ratings. Jeep Wrangler, Dodge, Ford F150, Chevy Silverado Mods reviews and News!";

const expludedFromRenderOnIndexPage = [
  'best-supercharger-for-jeep-jk',
  'best-tacoma-lift-kit',
  'best-shocks-and-struts-for-toyota-tundra',
  'best-jeep-wrangler-seat-covers',
  'best-jeep-wrangler-seat-covers'
]

export default class IndexPage extends React.Component {
  render() {
    const { data } = this.props
    const { edges: reviews } = data.reviewsData

    const cards = [...reviews]
    .filter((item) => !expludedFromRenderOnIndexPage.includes(item.node.fields.slug))
    .map((item) => ({
      id: item.node.id,
      slug: item.node.fields.slug,
      title: utils.updateYearToCurrent(item.node.frontmatter.title),
      excerpt: item.node.frontmatter.introduction || item.node.excerpt,
      created: item.node.frontmatter.created,
      author: item.node.frontmatter.seo.author,
      image: item.node.frontmatter.image,
    }));

    return (
      <Layout>
        <StructuredData isReview={false} />
        <SeoTags
          title={TITLE}
          description={DESCRIPTION}
        />
        <div>
          <Jumbotron
            isIndexPage
            title="Autokwix - Tune your beast"
            subheading="Start looking at reviews right now!"
            image="/img/jumbotron_off-road.jpg"
            alt="Autokwix"
          />
          <CardGrid data={cards} tag="#FEATURED" />
        </div>
        <div style={{'display': 'flex', 'justify-content': 'center'}}>
            <Link className="amazon-link amazon-link--is-black" to={`/articles/`}>ALL ARTICLES</Link>
        </div>
      </Layout>
    )
  }
}

IndexPage.propTypes = {
  data: PropTypes.shape({
    reviewsData: PropTypes.shape({
      edges: PropTypes.array,
    }),
    blogsData: PropTypes.shape({
      edges: PropTypes.array,
    }),
  }),
}

export const pageQuery = graphql`
  query IndexQuery {
    reviewsData: allMarkdownRemark(
      sort: { order: DESC, fields: [frontmatter___created] }
      filter: { frontmatter: { templateKey: { eq: "review-page" } } }
    ) {
      edges {
        node {
          id
          fields {
            slug
          }
          frontmatter {
            slug
            title
            introduction
            image
            seo {
              author
            }
            created(formatString: "MMMM DD, YYYY")
          }
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/pages/index.js